import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import AdminTextInput from '../../../components/admin/admin-text-input.js';
import { getCompanies } from "../../../store/employee/actions";
import { showLoading, hideLoading } from "../../../store/loading-reducer";
import { AddUpdateShopMonitorIPs } from "../../../api/shopMonitorIpsApi";
import {
    getAllCompanyShopMonitorIPs,
    deleteCompanyShopMonitorIPs,
} from "../../../store/companyShopMonitorIPs/actions";
import { useAdminMenuContext } from "../../../context/AdminMenuContext";
import { DeleteConfrimationModal } from "../../../components/DeleteConfrimationModal/DeleteConfrimationModal";
import { AdminModal } from "../../../components/admin/admin-modal";
import { formatDate } from "../../../helpers/formatterHelper";
import AdminError from "../../../components/admin/admin-error.js";

function CompanyShopMonitorIPs() {
    const dispatch = useDispatch();
    const { companiesList } = useSelector((state) => state.employee);
    const [error, setError] = useState('');
    const { companyShopMonitorIPsList } = useSelector(
        (state) => state.companyShopMonitorIPs
    );

    const [filter, setFilter] = useState({ query: "", companyId: 0, start: 1, sort: 7, length: 100, });

    const [editLink, setEditLink] = useAdminMenuContext("");
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [deleteTarget, setDeleteTarget] = useState(null);
    console.log("editLink", editLink);
    const [shopMonitorIpsModel, setShopMonitorIpsModel] = useState({ id: 0, companyId: 0, name: "", ip: "" });

    const [showCompanyPopup, setShowCompanyPopup] = useState(false);
    const [selectedCompany, setSelectedCompany] = useState(null);
    const [showIpsModal, setShowIpsModal] = useState(false);

    const [validation, setValidation] = useState({
        name: true,
        ip: true,
    });

    useEffect(() => {
        document.title = "Company Shop Monitor IPs | CWP Employee Portal";
        dispatch(showLoading());
        dispatch(getCompanies()).finally(() => dispatch(hideLoading()));
        setEditLink("/");
    }, [dispatch, setEditLink]);

    useEffect(() => {
        dispatch(getAllCompanyShopMonitorIPs(filter))
            .unwrap()
            .finally(() => dispatch(hideLoading()));
    }, [dispatch, filter]);

    const handleDeleteTrigger = (item) => {
        setDeleteTarget({ id: item.id, message: "Are you sure you want to delete this IP?", title: item.name, description: `IP Address: ${item.ip}`, });
        setShowDeleteModal(true);
    };

    const handleDelete = (item) => {
        if (item?.id) {
            dispatch(deleteCompanyShopMonitorIPs(item.id));
        }
    };

    const handleAddEditTrigger = (company, ipItem = null) => {
        setShopMonitorIpsModel(
            ipItem || {
                id: 0,
                companyId: company.id,
                name: "",
                ip: "",
            }
        );

        setValidation({
            name: true,
            ip: true,
            nameError: '',
            ipError: ''
        });

        setError('');
        setShowIpsModal(true);
    };

    const handleSave = () => {
        dispatch(showLoading());
        var isValid = true;

        let validate = {
            nameError: '',
            ipError: '',
        };

        if (shopMonitorIpsModel == null || shopMonitorIpsModel.name == null || shopMonitorIpsModel.name == "") {
            validate.name = false;
            validate.nameError = "Name is required";
            isValid = false;
        }
        if (shopMonitorIpsModel == null || shopMonitorIpsModel.ip == null || shopMonitorIpsModel.ip == "") {
            validate.ip = false;
            validate.ipError = "IP Address is required";
            isValid = false;
        }

        setValidation({ ...validation, ...validate });
        if (isValid == false) {
            dispatch(hideLoading());
            return;
        }

        AddUpdateShopMonitorIPs(shopMonitorIpsModel)
            .then((response) => {
                if (response.data.success) {
                    setShowIpsModal(false);
                    dispatch(getAllCompanyShopMonitorIPs(filter));
                } else {
                    setError(response.data.message);
                }
            })
            .finally(() => dispatch(hideLoading()));
    };

    const openCompanyPopup = (company) => {
        setSelectedCompany(company);
        setShowCompanyPopup(true);
    };

    return (
        <>

            {showCompanyPopup && selectedCompany && (
                <AdminModal
                    show={showCompanyPopup}
                    adminModalClass="company-ips-list"
                    onClose={() => setShowCompanyPopup(false)}
                    model={selectedCompany}
                    hideButtons={true}
                >
                    {showDeleteModal && (
                        <DeleteConfrimationModal
                            show={showDeleteModal}
                            onClose={() => setShowDeleteModal(false)}
                            handleDelete={handleDelete}
                            model={deleteTarget}
                        />
                    )}
                    {/* Add/Edit IP Modal */}
                    {showIpsModal && (
                        <AdminModal
                            show={showIpsModal}
                            modalTitle={
                                shopMonitorIpsModel.id ? "Edit Shop Monitor IP" : "Add Shop Monitor IP"
                            }
                            adminModalClass="add-shop-monitor-ips-add-edit"
                            onClose={() => { setShowIpsModal(false); setError(''); }}
                            onSave={handleSave}
                            model={shopMonitorIpsModel}
                        >
                            <AdminError
                                message={error}
                                onClose={() => {
                                    setError('');
                                }}
                            ></AdminError>
                            <div className="admin-modal-row full">
                                <AdminTextInput
                                    label="Name"
                                    id="ip-name"
                                    value={shopMonitorIpsModel.name}
                                    isRequired={true}
                                    onChange={(value) => {
                                        setShopMonitorIpsModel({ ...shopMonitorIpsModel, name: value });
                                        setValidation({ ...validation, name: value != '' });
                                    }}
                                    validated={validation.name}
                                    requiredText={validation.nameError}
                                    placeholder="Enter Name"
                                />
                            </div>

                            <div className="admin-modal-row full">
                                <AdminTextInput
                                    label="IP Address"
                                    id="ip-address"
                                    value={shopMonitorIpsModel.ip}
                                    isRequired={true}
                                    onChange={(value) => {
                                        setShopMonitorIpsModel({ ...shopMonitorIpsModel, ip: value });
                                        setValidation({ ...validation, ip: value != '' });
                                    }}
                                    validated={validation.ip}
                                    requiredText={validation.ipError}
                                    placeholder="Enter IP Address"
                                />
                            </div>
                        </AdminModal>
                    )}
                    <div className="admin-page-title-wrap">
                        <h2 className="admin-modal-heading">{`${selectedCompany.abbreviatedName} - IPs`}</h2>
                        <button
                            className="admin-button"
                            onClick={() => handleAddEditTrigger(selectedCompany)}
                        >
                            <span>Add</span>
                            <span className="material-symbols-rounded">add</span>
                        </button>
                    </div>

                    <div className="admin-modal-row full">
                        <table className="admin-table" style={{ width: '100%' }}>
                            <thead>
                                <tr>
                                    <th onClick={() => setFilter({ ...filter, sort: filter.sort == 2 ? 3 : 2 })} className={filter.sort == 2 ? 'admin-table-name-cell sortable sorted-dn' : (filter.sort == 3 ? 'admin-table-name-cell sortable sorted-up' : 'admin-table-name-cell sortable')}>Name</th>
                                    <th onClick={() => setFilter({ ...filter, sort: filter.sort == 4 ? 5 : 4 })} className={filter.sort == 2 ? 'admin-table-name-cell sortable sorted-dn' : (filter.sort == 5 ? 'admin-table-name-cell sortable sorted-up' : 'admin-table-name-cell sortable')}>IP</th>
                                    <th onClick={() => setFilter({ ...filter, sort: filter.sort == 6 ? 7 : 6 })} className={filter.sort == 0 ? 'admin-table-name-cell sortable sorted-dn' : (filter.sort == 7 ? 'admin-table-name-cell sortable sorted-up' : 'admin-table-name-cell sortable')}>Created Date</th>
                                    <th className="admin-table-action-cell">&nbsp;</th>
                                </tr>
                            </thead>
                            <tbody>
                                {companyShopMonitorIPsList?.filter(
                                    (ip) => ip.companyId === selectedCompany.id
                                ).length > 0 ? (
                                    companyShopMonitorIPsList
                                        .filter((ip) => ip.companyId === selectedCompany.id)
                                        .map((ip) => (
                                            <tr key={ip.id}>
                                                <td>{ip.name}</td>
                                                <td>{ip.ip}</td>
                                                <td>{ip.createdDate ? formatDate(ip.createdDate) : "-"}</td>
                                                <td>
                                                    <span className="admin-page-title-wrap" style={{ gap: 0 }}>
                                                        <button
                                                            className="admin-table-action"
                                                            onClick={() => handleAddEditTrigger(selectedCompany, ip)}
                                                        >
                                                            <span className="material-symbols-rounded">edit</span>
                                                        </button>
                                                        <button
                                                            className="admin-table-action"
                                                            onClick={() => handleDeleteTrigger(ip)}
                                                        >
                                                            <span className="material-symbols-rounded">delete</span>
                                                        </button>
                                                    </span>
                                                </td>
                                            </tr>
                                        ))
                                ) : (
                                    <tr>
                                        <td colSpan="4">No IPs found for this company</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </AdminModal>
            )}

            {/* Main Page */}
            <div className="admin-page-wrap">
                <div className="admin-top-bar-wrap">
                    <div className="admin-top-bar-left">
                        <Link className="admin-top-bar-back" to={"/siteadmin"}>
                            Back
                        </Link>
                    </div>
                </div>

                <div className="pageContainer">
                    <div className="admin-page-content">
                        <div className="admin-page-title-wrap">
                            <h1 className="admin-page-heading">Company Shop Monitor IPs</h1>
                        </div>

                        <div className="pt">
                            <table className="admin-table">
                                <thead>
                                    <tr>
                                        <th>Company</th>
                                        <th>Manage IPs</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {companiesList?.length > 0 ? (
                                        companiesList.map((company) => (
                                            <tr key={company.id}>
                                                <td>{company.abbreviatedName}</td>
                                                <td>
                                                    <button
                                                        className="admin-table-action"
                                                        onClick={() => openCompanyPopup(company)}
                                                    >
                                                        <span className="material-symbols-rounded">visibility</span>
                                                    </button>
                                                </td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="4">No Companies Found</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default CompanyShopMonitorIPs;
